module.exports = __webpack_public_path__ + "img/program_icon04.23d32d45.png";